import { MouseEvent, useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { CustomAlert, CustomButton, Text } from '../../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../../shared/Helpers/functions';
import { Archive as ArchiveIcon, Unarchive } from '../../../../../shared/Assets/svgIcons';

import { DispatchProperties, useSelector } from '../../../../../redux/store';
import { SkillProperties } from '../../../../../redux/API/ClientAPIHelpers/skillAreaProperties';
import {
	archiveSkillArea,
	getSkillAreas,
	unArchiveSkillArea,
} from '../../../../../redux/State/clientSlice/skillAreaSlice';
import { ButtonWrapper } from '../../../../../components/StyledComponents';

const Archive = ({ item }: { item: SkillProperties }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const [open, setOpen] = useState<boolean>(false);

	const refreshSkillAreas = () => {
		const { clientId } = item;

		if (!clientId) return;
		dispatch(getSkillAreas({ clientId }));
	};

	const onArchiveClick = (event: MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation();
		const { clientId, id } = item;
		if (!clientId || !id) return;
		dispatch(archiveSkillArea({ clientId, id }))
			.then(unwrapResult)
			.then(() => {
				refreshSkillAreas();
				toast('Success');
			})
			.catch(errorNormalizer);
	};

	const onUnarchiveClick = (event: MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation();
		const { clientId, id } = item;
		if (!clientId || !id) return;
		dispatch(unArchiveSkillArea({ clientId, id }))
			.then(unwrapResult)
			.then(() => {
				refreshSkillAreas();
				toast('Success');
			})
			.catch(errorNormalizer);
	};

	const openHandler = () => setOpen(true);
	const closeHandler = () => setOpen(false);

	const Icon = item.isArchived ? Unarchive : ArchiveIcon;
	const label = item.isArchived ? 'Unarchive' : 'Archive';
	const action = item.isArchived ? onUnarchiveClick : onArchiveClick;
	const isArchiving = useSelector((state) => state.skillArea.isArchiving);

	return (
		<>
			<div className="actionRow" onClick={openHandler}>
				<div className="actionIcon">
					<Icon />
				</div>
				<div className="actionContent">
					<Text title={label} type="psm" fontWeight="medium" />
				</div>
			</div>
			<CustomAlert
				isBusy={isArchiving}
				open={open}
				onClose={closeHandler}
				title={`Do you want to ${label} the selected skill area?`}
				Content={() => (
					<ButtonWrapper isInModal>
						<CustomButton title="Yes" onClick={action} />
						<CustomButton title="No" buttonType="secondaryGray" onClick={closeHandler} />
					</ButtonWrapper>
				)}
			/>
		</>
	);
};

export default Archive;
